import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CooperationDetails from "../../components/Cooperations/CooperationDetails";

const CooperationsShow = ({cooperation, backLink}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('cooperations.contract')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('default.nav.back'),
                    href: backLink,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(backLink);
                    },
                    color: 'secondary',
                },
                {
                    icon: 'edit',
                    text: i18n.get('cooperations.edit'),
                    href: `/cooperation/${cooperation.id}/edit`,
                }
            ]}
        />

                <CooperationDetails cooperation={cooperation}/>
    </Layout>
);

export default CooperationsShow;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/cooperations/Show.jsx